import React, { useState, useEffect } from 'react';
import ReactHtmlParser from 'html-react-parser';
import Element from '../../../../components/element';
import { CheckboxGroup, Checkbox } from 'react-checkbox-group';
import { includes, map } from 'lodash';

const CheckboxSurvey = props => {
  const {
    options,
    columns,
    question,
    rawAnswers,
    fullWidth,
    className,
    horizontal,
    storeAnswer,
    questionId,
    showOthers,
    text,
    fontSize
  } = props;
  // Initialize the checked values
  const [state, setState] = useState({
    selected: [],
    others: '',
    displayText: false
  });

  const onCheckChange = values => {
    const newState = { ...state, selected: values };
    newState.displayText = includes(values, showOthers) || includes(values, `${showOthers}-${rawAnswers?.others}`);
    setState(newState);
    storeAnswer(questionId, newState, isQuestionAnswered(newState));
  };

  const handleChange = e => {
    const value = e.target.value;
    const newState = { ...state, others: value };
    setState(newState);
    storeAnswer(questionId, newState, isQuestionAnswered(newState));
  };

  const isQuestionAnswered = state => {
    return !!(state.selected.length || state.others);
  };

  useEffect(() => {
    if (rawAnswers) {
      setState(rawAnswers);
    }
  }, [rawAnswers]);

  let options1 = [...options];
  let options2 = [];
  if (columns) {
    const num = Math.round(options.length / 2);
    options2 = options1.splice(num);
  }

  return (
    <div className={className}>
      <Element type="p" fontFamily="GTAM" fontSize="14px">
        {ReactHtmlParser(question)}
      </Element>
      <Element
        {...(text && text.horizontal && { display: 'flex', alignItems: 'end' })}
        {...(columns && { display: 'flex', alignItems: 'normal' })}
      >
        <Element
          type={CheckboxGroup}
          attrs={{
            name: questionId,
            value: state.selected,
            onChange: onCheckChange
          }}
        >
          {map(options1, option => {
            const keyOrId = `${questionId}_${option}`;
            return (
              <Element display="flex" alignItems="center" marginBottom="12px">
                <Checkbox key={keyOrId} id={keyOrId}
                  value={option == 'Other' && rawAnswers?.selected?.includes(`Other-${rawAnswers.others}`) ? `Other-${rawAnswers?.others}` : option}
                />
                <Element
                  type="label"
                  attrs={{ htmlFor: keyOrId }}
                  marginBottom={0}
                  marginLeft="8px"
                  fontFamily="GTAR"
                  fontSize={fontSize || '14px'}
                >
                  {option}
                </Element>
              </Element>
            );
          })}
          {includes(options1, showOthers) && (state.displayText || rawAnswers?.selected?.includes(`Other-${rawAnswers.others}`)) && (
            <Element
              type="input"
              attrs={{
                type: 'text',
                onChange: handleChange,
                value: state.others || rawAnswers?.others
              }}
              className={`survey-text survey-item-${text.size}`}

            // style={{
            //   ...(text && text.width && { width: text.width })
            // }}
            />
          )}
        </Element>
        <Element
          type={CheckboxGroup}
          attrs={{
            name: questionId,
            value: state.selected,
            onChange: onCheckChange
          }}
          marginLeft="50px"
        >
          {map(options2, option => {
            const keyOrId = `${questionId}_${option}`;

            return (
              <Element display="flex" alignItems="center" marginBottom="12px">
                <Checkbox key={keyOrId} id={keyOrId}
                  value={option == 'Other' && rawAnswers?.selected?.includes(`Other-${rawAnswers.others}`) ? `Other-${rawAnswers?.others}` : option}
                />
                <Element
                  type="label"
                  attrs={{ htmlFor: keyOrId }}
                  marginBottom={0}
                  marginLeft="8px"
                  fontFamily="GTAR"
                  fontSize="14px"
                >
                  {option}
                </Element>
              </Element>
            );
          })}
          {includes(options2, showOthers) && (state.displayText || rawAnswers?.selected?.includes(`Other-${rawAnswers.others}`)) && (
            <Element
              type="input"
              attrs={{
                type: 'text',
                onChange: handleChange,
                value: state.others || rawAnswers?.others
              }}
              className={`survey-text survey-item-${text.size}`}
            // style={{
            //   ...(text && text.width && { width: text.width })
            // }}
            />
          )}
        </Element>
      </Element>
    </div>
  );
};

export default CheckboxSurvey;
